import { authHeader } from './authservice/auth-header';
import { apiConfig } from "@/state/helpers";

export const areaService = {
    getAll
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${apiConfig.apiUrl}/area`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
    });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.info) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}